import { Contract, ethers } from "ethers";
import dayjs from 'dayjs'

import Message from "@/components/Message/index";
import { firstUpperCase } from "@/utils/index"

const getDayTime = () => dayjs().format('YYYY-MM-DD HH:mm:ss')
const generateLoginMessage = (account, nonce) => {
  if (!nonce) {
    return {
      oMessage: {}, sMessage: ''
    }
  }
  const oMessage = {
    'Message': 'SIGN THIS MESSAGE TO CONNECT THE DMAIL SNAP',
    'ADDRESS': account,
    'NONCE': nonce,
    'CURRENT TIME': getDayTime(),
  }
  const keys = Object.keys(oMessage) 
  const sMessage = keys.reduce((str, key, index) => {
    str += `${key === 'Message' ? '' : (key + ': \n')}${oMessage[key]}${index !== keys.length-1 ? '\n\n' : ''}`
    return str
  }, '')
  return {
    oMessage, sMessage
  }
}

const getNonce = async () => {
  const response = await fetch('https://icp.dmail.ai/dmailServer/api/snap/getNonce')
  const res = await response.json();
  // console.log(res)
  // console.log(res?.data?.nonce)
  return res?.data?.nonce
}

export const signMessage = async (provider, account) => {
  const { oMessage, sMessage } = generateLoginMessage(account, await getNonce());
  // const loginMessageHash = hashMessage(sMessage);

  try {
    const ethersProvider = new ethers.providers.Web3Provider(provider);
    const signer = ethersProvider.getSigner();
    // https://docs.ethers.org/v5/api/signer/#Signer-signMessage
    const signature = await signer.signMessage(sMessage)

    // [sMessage, account] or [account, sMessage] both right !!!...
    //  personal_sign throw errors in trust wallet
    // Reference: https://docs.walletconnect.com/1.0/quick-start/dapps/client#sign-personal-message-personal_sign
    // const signature = await provider.request({ method: "personal_sign", params: [sMessage, account] })
    return {
      signature,
      oMessage,
    }
  } catch (error) {
    // console.log('signMessage', error, typeof error)
    let isMessageObj = false
    try {
      // for walletconnect mobile sign error
      const o = error ? JSON.parse(error?.message) : ''
      if (typeof o === 'object' && o.message) {
        Message.error(o.message);
        console.error(error)
        isMessageObj = true
      }
    } catch (error) {
      //
    }
    if (!isMessageObj) {
      // for walletconnect mobile sign error
      if (typeof error === 'object' && error.toString().includes("Cannot read properties of undefined (reading 'includes')")) {
        return null
      } else if (error && typeof error.reason === 'string' && error.reason) {
        Message.error(firstUpperCase(error.reason));
        console.error(error.reason)
      } else {
        Message.error(error ? error.message : "Unknown error");
        console.error(error ? error.message : "Unknown error")
      }
    }
    
    return null
  }
}